import { useLogger } from '#apps/client-web/app/hooks/use-logger';
import { createLocalDatabase } from '#apps/client-web/app/utils/local-database';

import { userSettingsSchema, type UserSettings } from '../models/user-settings';

export class UserSettingsRepo {
  protected static readonly logger = useLogger(
    'features/user-settings/services/user-settings-repo',
  );

  protected static readonly SETTINGS_KEY = 'v1';
  protected static readonly repo = createLocalDatabase('user-settings');

  static async get(): Promise<UserSettings> {
    const item = await UserSettingsRepo.repo.getItem<UserSettings>(
      UserSettingsRepo.SETTINGS_KEY,
    );

    UserSettingsRepo.logger.debug({ item }, 'Fetched user settings from repo');

    return item ?? userSettingsSchema.parse({});
  }

  static async update(newSettings: UserSettings): Promise<void> {
    UserSettingsRepo.logger.debug(
      { newSettings },
      'Updating user settings in repo',
    );

    await UserSettingsRepo.repo.setItem(
      UserSettingsRepo.SETTINGS_KEY,
      newSettings,
    );
  }
}
